import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { showMyWallets } from "../../../../redux/wallet/walletActions";
import Button from "../../../../components/buttons/buttons";
import UserWallets from './tabs/UserWallets';
import WalletTransactions from './tabs/WalletTransactions';
import Empty from "../../../../assets/images/emptyState/payment.svg";

export default function MyWallet() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { myWallets } = useSelector((state) => state.wallet);

  const [selectedWallet, setSelectedWallet] = useState(null);
  const [showBalance, setShowBalance] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(showMyWallets());
  }, [dispatch]);

  useEffect(() => {
    if (myWallets?.data?.length > 0 && !selectedWallet) {
      setSelectedWallet(myWallets.data[0]);
    }
  }, [myWallets, selectedWallet]);

  const handleSelectWallet = (wallet) => {
    setSelectedWallet(wallet);
  };

  const handleToggleBalance = () => {
    setShowBalance(!showBalance);
  };

  if (!myWallets?.data || myWallets.data.length === 0) {
    return (
      <div className="sm:w-[820px] w-full mt-10 sm:ml-10 sm:mt-0 px-4 sm:px-6 bg-white dark:bg-[#121212] rounded-sm shadow-2xl">
        <div className="py-4 sm:py-5">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-white">Wallet(s)</h2>
        </div>
        <div className="my-10 pb-10 text-center">
          <img
            src={Empty}
            alt="empty state"
            className="flex justify-center mx-auto mb-4 w-32 h-32"
          />
          <p className="font-bold mb-2 text-gray-900 dark:text-white">No Wallet</p>
          <p className="text-sm text-gray-400">
            You don't have any wallets yet.
          </p>
        </div>
        <Button.Secondary
          type="button"
          title={"Back"}
          className={"sm:hidden rounded-md mb-8 sm:mb-0 w-full"}
          onClick={() => navigate("/profile")}
        />
      </div>
    );
  }

  return (
    <div>
      <div className="sm:w-[820px] w-full mt-10 sm:ml-10 sm:mt-0 px-4 sm:px-6 bg-white dark:bg-[#121212] rounded-sm shadow-2xl">
        <div className="border-b-2 py-4 sm:py-6 mb-6 flex sm:block justify-between items-center">
          <p className="text-base font-medium text-gray-800 dark:text-white text-center">
            Wallet(s)
          </p>
        </div>

        {/* Wallet Selector and Balance */}
        <UserWallets
          wallets={myWallets.data}
          selectedWallet={selectedWallet}
          onSelectWallet={handleSelectWallet}
          showBalance={showBalance}
          onToggleBalance={handleToggleBalance}
        />

        {/* Wallet Transactions */}
        {selectedWallet && (
          <WalletTransactions selectedWallet={selectedWallet} />
        )}

        <Button.Secondary
          type="button"
          title={"Back"}
          className={"sm:hidden rounded-md mb-8 sm:mb-0 w-full"}
          onClick={() => navigate("/profile")}
        />
      </div>
    </div>
  );
}
